import { render, staticRenderFns } from "./group-3.vue?vue&type=template&id=5da01176&"
import script from "./group-3.vue?vue&type=script&lang=js&"
export * from "./group-3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports